import { render, staticRenderFns } from "./WorldmapView.vue?vue&type=template&id=aa549ed2&"
import script from "./WorldmapView.vue?vue&type=script&lang=js&"
export * from "./WorldmapView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports